import React from "react";
import Friends from "./Friends";

const Main = () => {
  return (
    <>
      <Friends />
    </>
  );
};

export default Main;
